import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSupabaseClient } from 'src/api/supabase'
import { Database } from 'supabase/database.types'

import { queryKeys } from './queryKeys'

export type DecorationInfo_ =
  Database['public']['Tables']['decoration_info']['Row']
export type DecorationSetupCost_ =
  Database['public']['Tables']['decoration_setup_cost']['Row']
export type DecorationUnitCost_ =
  Database['public']['Tables']['decoration_unit_cost']['Row']

type CreateDecorationInsert = {
  name: string | null
  print_code: string | null
  locations: string | null
  vendor: string | null
  production_time_days: number | null
}

export const useCreateDecorations = () => {
  const supabase = useSupabaseClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (inserts: CreateDecorationInsert[]) => {
      const rows = inserts.map((r) => ({
        name: r.name,
        print_codes: r.print_code ? [r.print_code] : null,
      }))
      const { error } = await supabase.from('decoration_info').insert(rows)
      if (error) throw error
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.decorations] })
    },
  })
}
